// Formattazione e mapping di presentazione (italiano).
import type { DocumentType } from '@shared/types';

/** Sigla mono per icon-chip tipo documento (README §6.2). */
export const DOC_SIGLA: Record<DocumentType, string> = {
  cie: 'CIE',
  patente: 'PAT',
  passaporto: 'PSP',
  tessera_sanitaria: 'TS',
  altro: 'DOC',
};

export const DOC_LABEL: Record<DocumentType, string> = {
  cie: "Carta d'identità",
  patente: 'Patente',
  passaporto: 'Passaporto',
  tessera_sanitaria: 'Tessera sanitaria',
  altro: 'Altro',
};

export function euro(cents: number | null | undefined): string {
  if (cents == null) return '—';
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

export function dateIT(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso.length <= 10 ? iso + 'T00:00:00' : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function dateLongIT(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso.length <= 10 ? iso + 'T00:00:00' : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Badge tempo residuo: "21 g" se ≤30, altrimenti "1a 4m". */
export function timeLeftBadge(daysLeft: number): string {
  if (daysLeft < 0) return 'Scaduta';
  if (daysLeft <= 30) return `${daysLeft} g`;
  const years = Math.floor(daysLeft / 365);
  const months = Math.round((daysLeft % 365) / 30);
  if (years > 0) return months > 0 ? `${years}a ${months}m` : `${years}a`;
  return `${months}m`;
}

/** Etichette leggibili per le chiavi di fields_json. */
export function fieldLabel(key: string): string {
  const map: Record<string, string> = {
    data_nascita: 'Data di nascita',
    luogo_nascita: 'Luogo di nascita',
    cittadinanza: 'Cittadinanza',
    comune_rilascio: 'Comune di rilascio',
    categorie: 'Categorie',
    rilasciata_da: 'Rilasciata da',
    punti: 'Punti',
    autorita: 'Autorità',
    codice_fiscale: 'Codice fiscale',
    relazione: 'Relazione',
  };
  return map[key] ?? key.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}
